import component from './FormBuilder.vue'
export default component
